const occupationList = [
  {
    en: '911 Dispatcher',
    es: '911 Dispatcher',
  },
  {
    en: 'Account Executive',
    es: 'Account Executive',
  },
  {
    en: 'Account Manager',
    es: 'Account Manager',
  },
  {
    en: 'Accountant',
    es: 'Accountant - Contador',
  },
  {
    en: 'Accounting Manager',
    es: 'Accounting Manager',
  },
  {
    en: 'Accounts Collector',
    es: 'Accounts Collector',
  },
  {
    en: 'Actor',
    es: 'Actor - Actor',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Actor (performs own stunts)',
    es: 'Actor (performs own stunts) - Actor (realiza sus propios trucos)',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Actress',
    es: 'Actress',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Actuary',
    es: 'Actuary - Actuario',
  },
  {
    en: 'Acupuncturist',
    es: 'Acupuncturist',
  },
  {
    en: 'Adjuster',
    es: 'Adjuster - Perito',
  },
  {
    en: 'Administrative Assistant',
    es: 'Administrative Assistant',
  },
  {
    en: 'Advertising Artist',
    es: 'Advertising Artist',
  },
  {
    en: 'Advertising Executive',
    es: 'Advertising Executive',
  },
  {
    en: 'Advertising Sales',
    es: 'Advertising Sales',
  },
  {
    en: 'Aerial Photographer',
    es: 'Aerial Photographer',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Aerobics Instructor',
    es: 'Aerobics Instructor',
  },
  {
    en: 'Agent',
    es: 'Agent - Agente',
  },
  {
    en: 'Agriculture Manager',
    es: 'Agriculture Manager',
  },
  {
    en: 'Air Ambulance',
    es: 'Air Ambulance - Ambulancia aérea',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Air Force',
    es: 'Air Force',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Air Traffic Controller',
    es: 'Air Traffic Controller',
  },
  {
    en: 'Airline Administrative Personnel',
    es: 'Airline Administrative Personnel',
  },
  {
    en: 'Airline Ground Crew',
    es: 'Airline Ground Crew',
  },
  {
    en: 'Airline Ticket Reservations',
    es: 'Airline Ticket Reservations',
  },
  {
    en: 'Allergist',
    es: 'Allergist',
  },
  {
    en: 'Alumni Director',
    es: 'Alumni Director',
  },
  {
    en: 'Ambulance Driver',
    es: 'Ambulance Driver',
  },
  {
    en: 'Amusement Park Worker',
    es: 'Amusement Park Worker',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Analyst',
    es: 'Analyst - Analista',
  },
  {
    en: 'Anesthesiologist',
    es: 'Anesthesiologist - Anestesiólogo',
  },
  {
    en: 'Anesthetist',
    es: 'Anesthetist - Anestesista',
  },
  {
    en: 'Animal Handler',
    es: 'Animal Handler',
  },
  {
    en: 'Animal Trainer',
    es: 'Animal Trainer',
  },
  {
    en: 'Announcer',
    es: 'Announcer - Locutor',
  },
  {
    en: 'Antique Dealer',
    es: 'Antique Dealer',
  },
  {
    en: 'Appraiser',
    es: 'Appraiser',
  },
  {
    en: 'Arborist',
    es: 'Arborist',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Archaeologist',
    es: 'Archaeologist',
  },
  {
    en: 'Architect',
    es: 'Architect - Arquitecto',
  },
  {
    en: 'Armed Forces Personnel',
    es: 'Armed Forces Personnel',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Armored Car Personnel',
    es: 'Armored Car Personnel',
  },
  {
    en: 'Army',
    es: 'Army',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Art Director',
    es: 'Art Director',
  },
  {
    en: 'Art Gallery Curator',
    es: 'Art Gallery Curator',
  },
  {
    en: 'Art Restorer',
    es: 'Art Restorer',
  },
  {
    en: 'Artist',
    es: 'Artist - Artista',
  },
  {
    en: 'Asbestos Removal',
    es: 'Asbestos Removal - Remoción de asbesto',
    flatExtra: 5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Assistant',
    es: 'Assistant - Asistente',
  },
  {
    en: 'Assistant to the Regional Manager',
    es: 'Assistant to the Regional Manager',
  },
  {
    en: 'Astronaut',
    es: 'Astronaut',
    flatExtra: 20,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Athlete - Boxer',
    es: 'Athlete - Boxer - Atleta - Boxeador',
    flatExtra: 5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Athlete - Other Professional Athlete',
    es: 'Athlete - Other Professional Athlete - Atleta - Otro atleta profesional',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Athlete - Rodeo/Bronco/Bull Riding',
    es: 'Athlete - Rodeo/Bronco/Bull Riding - Atleta - Rodeo/Bronco/Monta de toros',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Athletic Director',
    es: 'Athletic Director',
  },
  {
    en: 'Athletics Business Agent',
    es: 'Athletics Business Agent',
  },
  {
    en: 'Attendant',
    es: 'Attendant - Encargado',
  },
  {
    en: 'Attorney',
    es: 'Attorney - Fiscal',
  },
  {
    en: 'Auctioneer',
    es: 'Auctioneer - Subastador',
  },
  {
    en: 'Auctioneer',
    es: 'Licensed Auctioneer',
  },
  {
    en: 'Audiologist',
    es: 'Audiologist',
  },
  {
    en: 'Auditor',
    es: 'Auditor - Auditor',
  },
  {
    en: 'Author',
    es: 'Author',
  },
  {
    en: 'Auto Dealership Owner/Manager',
    es: 'Auto Dealership Owner',
  },
  {
    en: 'Auto Mechanic',
    es: 'Auto Mechanic',
  },
  {
    en: 'Auto Sales',
    es: 'Auto Sales',
  },
  {
    en: 'Auto Service Manager',
    es: 'Auto Service Manager',
  },
  {
    en: 'Auto Washer',
    es: 'Auto Washer',
  },
  {
    en: 'Auto-Body Repairman',
    es: 'Auto-Body Repairman',
  },
  {
    en: 'Automotive Supplies',
    es: 'Automotive Supplies',
  },
  {
    en: 'Bacteriologist',
    es: 'Bacteriologist',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Baggage Agent',
    es: 'Baggage Agent',
  },
  {
    en: 'Baggage Handler',
    es: 'Baggage Handler',
  },
  {
    en: 'Bail Bonds',
    es: 'Bail Bonds',
  },
  {
    en: 'Baker',
    es: 'Baker - Panadero',
  },
  {
    en: 'Bakery Delivery',
    es: 'Bakery Delivery',
  },
  {
    en: 'Bakery Owner',
    es: 'Bakery Owner',
  },
  {
    en: 'Bakery Shop Worker',
    es: 'Bakery Shop Worker',
  },
  {
    en: 'Bank Clerk',
    es: 'Bank Clerk',
  },
  {
    en: 'Bank Executive',
    es: 'Bank Executive - Ejecutivo bancario',
  },
  {
    en: 'Bank Guard',
    es: 'Bank Guard',
  },
  {
    en: 'Bank Manager',
    es: 'Bank Manager',
  },
  {
    en: 'Bank Officer',
    es: 'Bank Officer',
  },
  {
    en: 'Bank Teller',
    es: 'Bank Teller',
  },
  {
    en: 'Banker',
    es: 'Banker - Banquero',
  },
  {
    en: 'Bar Manager',
    es: 'Bar Manager',
  },
  {
    en: 'Barber',
    es: 'Barber',
  },
  {
    en: 'Bartender',
    es: 'Bartender - Barman',
  },
  {
    en: "Bartender (Gentleman's/Exotic Clubs)",
    es: "Bartender (Gentleman's/Exotic Clubs) - Barman (Clubes exóticos para caballeros)",
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Beautician',
    es: 'Beautician - Esteticista',
  },
  {
    en: 'Bellboy',
    es: 'Bellboy',
  },
  {
    en: 'Biochemist',
    es: 'Biochemist',
  },
  {
    en: 'Biologist',
    es: 'Biologist',
  },
  {
    en: 'Blacksmith',
    es: 'Blacksmith',
  },
  {
    en: 'Blaster or Explosives Handler',
    es: 'Blaster or Explosives Handler',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Bond Broker',
    es: 'Bond Broker',
  },
  {
    en: 'Bond Trader',
    es: 'Bond Trader',
  },
  {
    en: 'Bookbinder',
    es: 'Bookbinder',
  },
  {
    en: 'Booking Agent',
    es: 'Booking Agent',
  },
  {
    en: 'Bookkeeper',
    es: 'Bookkeeper - Tenedor de libros',
  },
  {
    en: 'Border Patrol',
    es: 'Border Patrol - Patrulla de frontera',
  },
  {
    en: 'Border Patrol (Mexico)',
    es: 'Border Patrol (Mexico) - Patrulla de frontera (México)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Botanist',
    es: 'Botanist',
  },
  {
    en: 'Bounty Hunter',
    es: 'Bounty Hunter',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Bowling Alley Attendant',
    es: 'Bowling Alley Attendant',
  },
  {
    en: 'Bowling Alley Manager',
    es: 'Bowling Alley Manager',
  },
  {
    en: 'Brakeman',
    es: 'Brakeman - Guardafrenos',
  },
  {
    en: 'Branch Manager',
    es: 'Branch Manager',
  },
  {
    en: 'Bricklayer',
    es: 'Bricklayer - Albañil',
  },
  {
    en: 'Broker',
    es: 'Broker - Corredor',
  },
  {
    en: 'Budget Analyst',
    es: 'Budget Analyst',
  },
  {
    en: 'Builder',
    es: 'Builder - Constructor',
  },
  {
    en: 'Building Inspector',
    es: 'Building Inspector',
  },
  {
    en: 'Building Superintendent',
    es: 'Building Superintendent',
  },
  {
    en: 'Building Supervisor',
    es: 'Building Supervisor',
  },
  {
    en: 'Building Wrecking',
    es: 'Building Wrecking',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Bus Driver',
    es: 'Bus Driver',
  },
  {
    en: 'Busboy',
    es: 'Busboy',
  },
  {
    en: 'Business Analyst',
    es: 'Business Analyst',
  },
  {
    en: 'Business Consultant',
    es: 'Business Consultant',
  },
  {
    en: 'Business Development Manager',
    es: 'Business Development Manager',
  },
  {
    en: 'Business Manager / Owner',
    es: 'Business Manager',
  },
  {
    en: 'Business Strategist',
    es: 'Business Strategist',
  },
  {
    en: 'Business Systems Analyst',
    es: 'Business Systems Analyst',
  },
  {
    en: 'Butcher',
    es: 'Butcher - Carnicero',
  },
  {
    en: 'Buyer',
    es: 'Buyer',
  },
  {
    en: 'Cabinet Maker',
    es: 'Cabinet Maker - Ebanista',
  },
  {
    en: 'Cameraman',
    es: 'Cameraman',
  },
  {
    en: 'Cantor',
    es: 'Cantor',
  },
  {
    en: 'Captain (ship/boat)',
    es: 'Captain (ship/boat)',
  },
  {
    en: 'Cardiologist',
    es: 'Cardiologist',
  },
  {
    en: 'Cardiovascular Surgeon',
    es: 'Cardiovascular Surgeon',
  },
  {
    en: 'Carnival/Circus/Fair Performer',
    es: 'Carnival/Circus/Fair Performer - Artista de carnaval/circo/feria',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Carpenter',
    es: 'Carpenter - Carpintero',
  },
  {
    en: 'Carpet Cleaner',
    es: 'Carpet Cleaner',
  },
  {
    en: 'Carpet Installer',
    es: 'Carpet Installer',
  },
  {
    en: 'Cartographer',
    es: 'Cartographer',
  },
  {
    en: 'Cartoonist',
    es: 'Cartoonist',
  },
  {
    en: 'Case Manager',
    es: 'Case Manager',
  },
  {
    en: 'Cashier',
    es: 'Cashier - Cajero',
  },
  {
    en: 'Casino Manager',
    es: 'Casino Manager',
  },
  {
    en: 'Casino Worker',
    es: 'Casino Worker',
  },
  {
    en: 'Catering Chef',
    es: 'Catering Chef',
  },
  {
    en: 'Catering Manager',
    es: 'Catering Manager',
  },
  {
    en: 'Catering Owner',
    es: 'Catering Owner',
  },
  {
    en: 'Cement or Concrete Work',
    es: 'Cement or Concrete Work',
  },
  {
    en: 'Cemetery Clerk',
    es: 'Cemetery Clerk',
  },
  {
    en: 'Census Taker',
    es: 'Census Taker - Censista',
  },
  {
    en: 'Certified Financial Planner',
    es: 'Certified Financial Planner',
  },
  {
    en: 'Certified Nursing Assistant (CNA)',
    es: 'CNA',
  },
  {
    en: 'Certified Public Accountant',
    es: 'Certified Public Accountant',
  },
  {
    en: 'Chambermaid',
    es: 'Chambermaid',
  },
  {
    en: 'Chauffeur',
    es: 'Chauffeur',
  },
  {
    en: 'Chef',
    es: 'Chef - Chef',
  },
  {
    en: 'Chemist',
    es: 'Chemist',
  },
  {
    en: 'Chief Executive Officer',
    es: 'Chief Executive Officer',
  },
  {
    en: 'Chief Financial Officer',
    es: 'Chief Financial Officer',
  },
  {
    en: 'Chief Operating Officer',
    es: 'Chief Operating Officer',
  },
  {
    en: 'Chief Technology Officer',
    es: 'CTO',
  },
  {
    en: 'Chimney Sweep',
    es: 'Chimney Sweep',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Chiropractor',
    es: 'Chiropractor - Quiropráctico',
  },
  {
    en: 'Civil Engineer',
    es: 'Civil Engineer',
  },
  {
    en: 'Claims Adjuster',
    es: 'Claims Adjuster',
  },
  {
    en: 'Clergyman',
    es: 'Clergyman - Clérigo',
  },
  {
    en: 'Clock Repair',
    es: 'Clock Repair',
  },
  {
    en: 'Coach',
    es: 'Coach',
  },
  {
    en: 'Coast Guard',
    es: 'Coast Guard',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'College Administrator',
    es: 'College Administrator',
  },
  {
    en: 'College Professor',
    es: 'College Professor - Profesor universitario',
  },
  {
    en: 'Commodity Trader',
    es: 'Commodity Trader',
  },
  {
    en: 'Compliance Officer',
    es: 'Compliance Officer',
  },
  {
    en: 'Compositor',
    es: 'Compositor',
  },
  {
    en: 'Comptroller',
    es: 'Comptroller',
  },
  {
    en: 'Computer Administrator',
    es: 'Computer Administrator',
  },
  {
    en: 'Computer Architect',
    es: 'Computer Architect',
  },
  {
    en: 'Computer Engineer',
    es: 'Computer Engineer',
  },
  {
    en: 'Computer Programmer',
    es: 'Computer Programmer - Programador informático',
  },
  {
    en: 'Computer Repairman',
    es: 'Computer Repairman',
  },
  {
    en: 'Conductor',
    es: 'Conductor',
  },
  {
    en: 'Construction Foreman/Supervisor',
    es: 'Construction Foreman/Supervisor - Capataz de la construcción/Supervisor',
  },
  {
    en: 'Construction Inspector',
    es: 'Construction Inspector',
  },
  {
    en: 'Construction Laborer',
    es: 'Construction Laborer - Obrero de la construcción',
  },
  {
    en: 'Construction Laborer - Iron & Steel Workers',
    es: 'Construction Laborer - Iron & Steel Workers - Obrero de la construcción –Obreros que trabajan en hierro y acero',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Construction Laborer - Tunnelers/Shafts/Dams/Caisson',
    es: 'Construction Laborer - Tunnelers/Shafts/Dams/Caisson',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Consultant',
    es: 'Consultant - Consultor',
  },
  {
    en: 'Contractor',
    es: 'Contractor - Contratista',
  },
  {
    en: 'Controller',
    es: 'Controller - Regulador',
  },
  {
    en: 'Cook',
    es: 'Cook - Cocinero',
  },
  {
    en: 'Copy Editor',
    es: 'Copy Editor',
  },
  {
    en: 'Copywriter',
    es: 'Copywriter',
  },
  {
    en: 'Corporate Executive',
    es: 'Corporate Executive',
  },
  {
    en: 'Correspondent',
    es: 'Correspondent',
  },
  {
    en: 'Cosmetologist',
    es: 'Cosmetologist',
  },
  {
    en: 'Counselor',
    es: 'Counselor - Consejero',
  },
  {
    en: 'Courier',
    es: 'Courier',
  },
  {
    en: 'Court Reporter',
    es: 'Court Reporter',
  },
  {
    en: 'Creative Director',
    es: 'Creative Director',
  },
  {
    en: 'Credit Analyst',
    es: 'Credit Analyst',
  },
  {
    en: 'Credit Investigator',
    es: 'Credit Investigator',
  },
  {
    en: 'Critical Care Specialist',
    es: 'Critical Care Specialist',
  },
  {
    en: 'Curator',
    es: 'Curator',
  },
  {
    en: 'Custodian',
    es: 'Custodian - Custodio',
  },
  {
    en: 'Customer Service Representative',
    es: 'Customer Service Representative',
  },
  {
    en: 'Dairy Inspector',
    es: 'Dairy Inspector',
  },
  {
    en: 'Dairy Owner/Manager',
    es: 'Dairy Manager',
  },
  {
    en: 'Dairy Worker',
    es: 'Dairy Worker',
  },
  {
    en: 'Dance Instructor',
    es: 'Dance Instructor',
  },
  {
    en: 'Dancer',
    es: 'Dancer - Bailarín',
  },
  {
    en: "Dancer (Gentleman's/Exotic Club)",
    es: "Dancer (Gentleman's/Exotic Club) - Bailarín (Clubes exóticos para caballeros)",
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Data Scientist',
    es: 'Data Scientist - Científico de datos',
  },
  {
    en: 'Database Administrator',
    es: 'Database Administrator',
  },
  {
    en: 'Database Analyst',
    es: 'Database Analyst',
  },
  {
    en: 'Day Care Operator',
    es: 'Day Care Operator',
  },
  {
    en: 'DEA',
    es: 'DEA',
  },
  {
    en: 'DEA (with foreign travel)',
    es: 'DEA (with foreign travel)',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Dean',
    es: 'Dean',
  },
  {
    en: 'Deckhand',
    es: 'Deckhand',
  },
  {
    en: 'Delivery Driver',
    es: 'Delivery Driver',
  },
  {
    en: 'Dental Assistant',
    es: 'Dental Assistant',
  },
  {
    en: 'Dental Hygienist',
    es: 'Dental Hygienist',
  },
  {
    en: 'Dental Lab Technician',
    es: 'Dental Lab Technician',
  },
  {
    en: 'Dentist',
    es: 'Dentist - Dentista',
  },
  {
    en: 'Dermatologist',
    es: 'Dermatologist',
  },
  {
    en: 'Designer',
    es: 'Designer - Diseñador',
  },
  {
    en: 'Detective',
    es: 'Detective',
  },
  {
    en: 'Developer',
    es: 'Developer',
  },
  {
    en: 'Dialysis Technician',
    es: 'Dialysis Technician',
  },
  {
    en: 'Diamond Cutter',
    es: 'Diamond Cutter',
  },
  {
    en: 'Dietitian',
    es: 'Dietitian',
  },
  {
    en: 'Digital Marketing Manager',
    es: 'Digital Marketing Manager',
  },
  {
    en: 'Director',
    es: 'Director - Director',
  },
  {
    en: 'Disc Jockey',
    es: 'Disc Jockey',
  },
  {
    en: 'Dishwasher',
    es: 'Dishwasher',
  },
  {
    en: 'Dispatcher',
    es: 'Dispatcher',
  },
  {
    en: 'Dispensary Worker (Marijuana) ',
    es: 'Dispensary Worker (Marijuana) ',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Diver',
    es: 'Diver - Buzo',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Dock Worker',
    es: 'Dock Worker',
  },
  {
    en: 'Doctor',
    es: 'Doctor - Médico',
  },
  {
    en: 'Domestic Worker',
    es: 'Domestic Worker',
  },
  {
    en: 'Doorman',
    es: 'Doorman',
  },
  {
    en: 'Draftsman',
    es: 'Draftsman - Dibujante',
  },
  {
    en: 'Dressmaker',
    es: 'Dressmaker',
  },
  {
    en: 'Driver',
    es: 'Driver - Conductor',
  },
  {
    en: 'Drug Store Clerk',
    es: 'Drug Store Clerk',
  },
  {
    en: 'Dry Cleaning/Laundry',
    es: 'Dry Cleaning/Laundry',
  },
  {
    en: 'ECG technician',
    es: 'ECG technician',
  },
  {
    en: 'Economist',
    es: 'Economist',
  },
  {
    en: 'Editor',
    es: 'Editor',
  },
  {
    en: 'Educator',
    es: 'Educator',
  },
  {
    en: 'Electrical Engineer',
    es: 'Electrical Engineer',
  },
  {
    en: 'Electrician',
    es: 'Electrician - Electricista',
  },
  {
    en: 'Electrologist',
    es: 'Electrologist',
  },
  {
    en: 'Electronics Technician',
    es: 'Electronics Technician',
  },
  {
    en: 'Electrotyper',
    es: 'Electrotyper',
  },
  {
    en: 'Elevator Inspector',
    es: 'Elevator Inspector',
  },
  {
    en: 'Elevator Installer',
    es: 'Elevator Installer',
  },
  {
    en: 'Elevator Mechanic',
    es: 'Elevator Mechanic',
  },
  {
    en: 'Elevator Operator',
    es: 'Elevator Operator',
  },
  {
    en: 'Embalmer',
    es: 'Embalmer',
  },
  {
    en: 'Embryologist',
    es: 'Embryologist',
  },
  {
    en: 'EMT (Emergency Medical Technician)',
    es: 'EMT (Emergency Medical Technician)',
  },
  {
    en: 'Endocrinologist',
    es: 'Endocrinologist',
  },
  {
    en: 'Endodontist',
    es: 'Endodontist',
  },
  {
    en: 'Engineer',
    es: 'Engineer - Ingeniero',
  },
  {
    en: 'Engineering Inspector',
    es: 'Engineering Inspector',
  },
  {
    en: 'Engraver',
    es: 'Engraver',
  },
  {
    en: 'ENT',
    es: 'ENT',
  },
  {
    en: 'Entertainer',
    es: 'Entertainer',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Entomologist',
    es: 'Entomologist',
  },
  {
    en: 'Entrepreneur',
    es: 'Entrepreneur',
  },
  {
    en: 'Event Planner',
    es: 'Event Planner',
  },
  {
    en: 'Executive',
    es: 'Executive - Ejecutivo',
  },
  {
    en: 'Executive Assistant',
    es: 'Executive Assistant',
  },
  {
    en: 'Executive Director',
    es: 'Executive Director',
  },
  {
    en: 'Exercise Instructor',
    es: 'Exercise Instructor',
  },
  {
    en: 'Exercise Psychologist',
    es: 'Exercise Psychologist',
  },
  {
    en: 'Exotic Dancer',
    es: 'Exotic Dancer',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Explosive and Munitions Plant Worker',
    es: 'Explosive and Munitions Plant Worker',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Explosives Test Driver',
    es: 'Explosives Test Driver',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Exterminator',
    es: 'Exterminator',
  },
  {
    en: 'Facilities Manager',
    es: 'Facilities Manager',
  },
  {
    en: 'Factory worker',
    es: 'Factory worker',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Family Practice Physician',
    es: 'Family Practice Physician',
  },
  {
    en: 'Farm Owner/Manager',
    es: 'Farm Manager',
  },
  {
    en: 'Farmer',
    es: 'Farmer',
  },
  {
    en: 'Farmer or Rancher (Laborer)',
    es: 'Farmer or Rancher (Laborer) - Agricultor o ganadero (obrero)',
  },
  {
    en: 'FBI',
    es: 'FBI',
  },
  {
    en: 'FBI (with foreign travel)',
    es: 'FBI (with foreign travel)',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Federal Marshal',
    es: 'Federal Marshal',
  },
  {
    en: 'Film Editor',
    es: 'Film Editor',
  },
  {
    en: 'Film Processor',
    es: 'Film Processor',
  },
  {
    en: 'Finance Director',
    es: 'Finance Director',
  },
  {
    en: 'Financial Analyst',
    es: 'Financial Analyst',
  },
  {
    en: 'Financial Consultant',
    es: 'Financial Consultant',
  },
  {
    en: 'Financial Manager',
    es: 'Financial Manager',
  },
  {
    en: 'Financial Planner',
    es: 'Financial Planner',
  },
  {
    en: 'Fire & Smoke Jumper',
    es: 'Fire & Smoke Jumper - Bombero paracaidista',
    flatExtra: 3.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Firefighter',
    es: 'Firefighter',
  },
  {
    en: 'Firefighter (Explosives/Munitions Plant)',
    es: 'Firefighter (Explosives/Munitions Plant) - Bombero (planta de explosivos/municiones)',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Firefighter (Gas Wells)',
    es: 'Firefighter (Gas Wells) - Bombero (de pozos de gas)',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Firefighter (Mining)',
    es: 'Firefighter (Mining) - Bombero (Minería)',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Firefighter (Nuclear Processing)',
    es: 'Firefighter (Nuclear Processing) - Bombero (procesamiento nuclear)',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Firefighter (Oil)',
    es: 'Firefighter (Oil) - Bombero (petróleo)',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Fireworks Manufacturing',
    es: 'Fireworks Manufacturing - Fabricación de fuegos artificiales',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Fisherman - return to shore each night',
    es: 'Fisherman',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Fisherman - Alaska Crab',
    es: 'Fisherman - Alaska Crab - Pescador - cangrejo de Alaska',
    flatExtra: 10,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Fisherman - stay out at night',
    es: 'Fisherman - stay out at night - Pescador - Permanece fuera durante la noche',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Fishery Processing or Hatchery Worker',
    es: 'Fishery Processing or Hatchery Worker',
  },
  {
    en: 'Fishery Supervisor',
    es: 'Fishery Supervisor',
  },
  {
    en: 'Flight Attendant',
    es: 'Flight Attendant',
  },
  {
    en: 'Flight Crew',
    es: 'Flight Crew - Tripulación de vuelo',
  },
  {
    en: 'Floor Traders',
    es: 'Floor Traders',
  },
  {
    en: 'Florist',
    es: 'Florist - Florista',
  },
  {
    en: 'Food Service Manager',
    es: 'Food Service Manager',
  },
  {
    en: 'Foreman',
    es: 'Foreman - Capataz',
  },
  {
    en: 'Forest Ranger',
    es: 'Forest Ranger',
  },
  {
    en: 'Freelance Writer',
    es: 'Freelance Writer',
  },
  {
    en: 'Freight Handler',
    es: 'Freight Handler',
  },
  {
    en: 'Fumigator',
    es: 'Fumigator',
  },
  {
    en: 'Funeral Director',
    es: 'Funeral Director - Director de funeraria',
  },
  {
    en: 'Furniture Mover',
    es: 'Furniture Mover',
  },
  {
    en: 'Furniture Refinishing',
    es: 'Furniture Refinishing',
  },
  {
    en: 'Furrier',
    es: 'Furrier',
  },
  {
    en: 'Garage Attendant',
    es: 'Garage Attendant',
  },
  {
    en: 'Garbage/Waste Collector',
    es: 'Garbage/Waste Collector - Recolector de residuos/basura',
  },
  {
    en: 'Gardener',
    es: 'Gardener - Jardinero',
  },
  {
    en: 'Gastroenterologist',
    es: 'Gastroenterologist',
  },
  {
    en: 'General Contractor',
    es: 'General Contractor',
  },
  {
    en: 'General Manager',
    es: 'General Manager',
  },
  {
    en: 'General Surgeon',
    es: 'General Surgeon',
  },
  {
    en: 'Geneticist',
    es: 'Geneticist',
  },
  {
    en: 'Geologist',
    es: 'Geologist - Geólogo',
  },
  {
    en: 'Geriatrician',
    es: 'Geriatrician',
  },
  {
    en: 'Glazier',
    es: 'Glazier',
  },
  {
    en: 'Golf Club Attendant',
    es: 'Golf Club Attendant',
  },
  {
    en: 'Golf Club Owner/Manager',
    es: 'Golf Club Manager',
  },
  {
    en: 'Golf Club Professional',
    es: 'Golf Club Professional',
  },
  {
    en: 'Golf Instructor',
    es: 'Golf Instructor',
  },
  {
    en: 'Golf Pro',
    es: 'Golf Pro',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Government Employee',
    es: 'Government Employee',
  },
  {
    en: 'Graphic Designer',
    es: 'Graphic Designer',
  },
  {
    en: 'Greenhouse Worker',
    es: 'Greenhouse Worker',
  },
  {
    en: 'Grocer',
    es: 'Grocer - Almacenero',
  },
  {
    en: 'Grocery Store Owner/Manager',
    es: 'Grocery Store Owner',
  },
  {
    en: 'Groomer',
    es: 'Groomer',
  },
  {
    en: 'Groundskeeper',
    es: 'Groundskeeper',
  },
  {
    en: 'Guidance Counselor',
    es: 'Guidance Counselor',
  },
  {
    en: 'Gunsmith',
    es: 'Gunsmith',
  },
  {
    en: 'Gynecologist',
    es: 'Gynecologist - Ginecólogo',
  },
  {
    en: 'Hair Stylist',
    es: 'Hair Stylist',
  },
  {
    en: 'Hairdresser',
    es: 'Hairdresser - Peluquero',
  },
  {
    en: 'Handler (Public Relations)',
    es: 'Handler (Public Relations)',
  },
  {
    en: 'Harbor Master',
    es: 'Harbor Master',
  },
  {
    en: 'Hardware Designer',
    es: 'Hardware Designer',
  },
  {
    en: 'Hardware Engineer',
    es: 'Hardware Engineer',
  },
  {
    en: 'Health Club Employee',
    es: 'Health Club Employee',
  },
  {
    en: 'Health Club Manager',
    es: 'Health Club Manager',
  },
  {
    en: 'Heavy Equipment Operator',
    es: 'Heavy Equipment Operator',
  },
  {
    en: 'Hedge Fund Manager',
    es: 'Hedge Fund Manager',
  },
  {
    en: 'Helicopter Lineman',
    es: 'Helicopter Lineman',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Helicopter Mechanic',
    es: 'Helicopter Mechanic',
  },
  {
    en: 'Hematologist',
    es: 'Hematologist',
  },
  {
    en: 'Higher Education Administration',
    es: 'Higher Education Administration',
  },
  {
    en: 'Hired Hand',
    es: 'Hired Hand',
  },
  {
    en: 'Homecare Administrator',
    es: 'Homecare Administrator',
  },
  {
    en: 'Homeland Security',
    es: 'Homeland Security',
  },
  {
    en: 'Homeland Security (with foreign travel)',
    es: 'Homeland Security (with foreign travel)',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Homeopath',
    es: 'Homeopath',
  },
  {
    en: 'Hospital Administrator',
    es: 'Hospital Administrator',
  },
  {
    en: 'Hospitalist',
    es: 'Hospitalist',
  },
  {
    en: 'Host/Hostess',
    es: 'Host/Hostess',
  },
  {
    en: 'Hotel Clerk',
    es: 'Hotel Clerk',
  },
  {
    en: 'Hotel Maintenance',
    es: 'Hotel Maintenance',
  },
  {
    en: 'Hotel Owner/Manager',
    es: 'Hotel Owner',
  },
  {
    en: 'Housekeeper',
    es: 'Housekeeper - Ama de llaves',
  },
  {
    en: 'Human Resource Manager',
    es: 'Human Resource Manager',
  },
  {
    en: 'Human Resources Director',
    es: 'Human Resources Director',
  },
  {
    en: 'HVAC Tech',
    es: 'HVAC Tech',
  },
  {
    en: 'Illustrator',
    es: 'Illustrator',
  },
  {
    en: 'Immunologist',
    es: 'Immunologist',
  },
  {
    en: 'Importer',
    es: 'Importer - Importador',
  },
  {
    en: 'Industrial Designer',
    es: 'Industrial Designer',
  },
  {
    en: 'Industrial Mechanic',
    es: 'Industrial Mechanic',
  },
  {
    en: 'Industrial Product Sales',
    es: 'Industrial Product Sales',
  },
  {
    en: 'Infertility Specialist',
    es: 'Infertility Specialist',
  },
  {
    en: 'Information Technology',
    es: 'Information Technology',
  },
  {
    en: 'Inn Owner/Manager',
    es: 'Inn Owner',
  },
  {
    en: 'Instructor',
    es: 'Instructor - Instructor',
  },
  {
    en: 'Insurance Adjuster',
    es: 'Insurance Adjuster',
  },
  {
    en: 'Insurance Agent',
    es: 'Insurance Agent - Agente de seguros',
  },
  {
    en: 'Insurance Broker',
    es: 'Insurance Broker',
  },
  {
    en: 'Insurance Clerk',
    es: 'Insurance Clerk',
  },
  {
    en: 'Insurance Inspector',
    es: 'Insurance Inspector',
  },
  {
    en: 'Interior Designer',
    es: 'Interior Designer',
  },
  {
    en: 'Internal Medicine',
    es: 'Internal Medicine',
  },
  {
    en: 'Interpreter',
    es: 'Interpreter',
  },
  {
    en: 'Intervention Neurosurgery RN',
    es: 'Intervention neurosurgery RN',
  },
  {
    en: 'Investigator',
    es: 'Investigator - Investigador',
  },
  {
    en: 'Investment Analyst',
    es: 'Investment Analyst',
  },
  {
    en: 'Investment Banker',
    es: 'Investment Banker',
  },
  {
    en: 'Investment Manager',
    es: 'Investment Manager',
  },
  {
    en: 'Investor',
    es: 'Investor',
  },
  {
    en: 'IT Analyst',
    es: 'IT Analyst',
  },
  {
    en: 'IT Auditor',
    es: 'IT Auditor',
  },
  {
    en: 'IT Consultant',
    es: 'IT Consultant',
  },
  {
    en: 'IT Engineer',
    es: 'IT Engineer',
  },
  {
    en: 'IT Manager',
    es: 'IT Manager',
  },
  {
    en: 'IT Professional',
    es: 'IT Professional',
  },
  {
    en: 'IT Support',
    es: 'IT Support',
  },
  {
    en: 'IT Systems Engineer',
    es: 'IT Systems Engineer',
  },
  {
    en: 'Janitor',
    es: 'Janitor - Portero',
  },
  {
    en: 'Jeweler',
    es: 'Jeweler - Joyero',
  },
  {
    en: 'Jewelry Appraiser',
    es: 'Jewelry Appraiser',
  },
  {
    en: 'Jewelry Merchant',
    es: 'Jewelry Merchant',
  },
  {
    en: 'Jockey',
    es: 'Jockey',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Journalist',
    es: 'Journalist',
  },
  {
    en: 'Journalist (with Foreign Travel)',
    es: 'Journalist, Freelance (with Foreign Travel) - Periodista Independiente (viaja al extranjero)',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Junk Proprietor',
    es: 'Junk Proprietor',
  },
  {
    en: 'Kennel Worker',
    es: 'Kennel Worker',
  },
  {
    en: 'Lab Technician',
    es: 'Lab Technician',
  },
  {
    en: 'Lab Technician (Alkalis/Acids/Explosives/Carcinogens)',
    es: 'Lab Technician (Alkalis/Acids/Explosives/Carcinogens)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Landscape Architect',
    es: 'Landscape Architect',
  },
  {
    en: 'Landscaper',
    es: 'Landscaper - Paisajista',
  },
  {
    en: 'Laundry Workers',
    es: 'Laundry Workers',
  },
  {
    en: 'Law Enforcement (K-9)',
    es: 'Law Enforcement (K-9) - Fuerzas policiales (K-9)',
  },
  {
    en: 'Law Enforcement (Other)',
    es: 'Law Enforcement (Other) - Fuerzas policiales (otro)',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Law Enforcement (Patrol/Office/Supervisor)',
    es: 'Law Enforcement (Patrol/Office/Supervisor) - Fuerzas policiales (patrulla/oficina/supervisor)',
  },
  {
    en: 'Lawyer',
    es: 'Lawyer - Abogado',
  },
  {
    en: 'LCSW',
    es: 'LCSW',
  },
  {
    en: 'Legal Assistant',
    es: 'Legal Assistant',
  },
  {
    en: 'Legal Secretary',
    es: 'Legal Secretary',
  },
  {
    en: 'Legal Transcriber',
    es: 'Legal Transcriber (Not At Home)',
  },
  {
    en: 'Lens Grinder',
    es: 'Lens Grinder',
  },
  {
    en: 'Librarian',
    es: 'Librarian - Bibliotecario',
  },
  {
    en: 'Licensed Practical Nurses (LPN)',
    es: 'Licensed Practical Nurses (LPN)',
  },
  {
    en: 'Lineman',
    es: 'Lineman - Operario de líneas eléctricas',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Linotype Operator',
    es: 'Linotype Operator',
  },
  {
    en: 'Liquor Store Owner/Manager',
    es: 'Liquor Store Owner',
  },
  {
    en: 'Literary Agent',
    es: 'Literary Agent',
  },
  {
    en: 'Lithographer',
    es: 'Lithographer',
  },
  {
    en: 'Loan Officer',
    es: 'Loan Officer',
  },
  {
    en: 'Lobbyist',
    es: 'Lobbyist',
  },
  {
    en: 'Locksmith',
    es: 'Locksmith',
  },
  {
    en: 'Logger',
    es: 'Logger',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Logistics Analyst',
    es: 'Logistics Analyst',
  },
  {
    en: 'Logistics Manager',
    es: 'Logistics Manager',
  },
  {
    en: 'Longshoreman',
    es: 'Longshoreman',
  },
  {
    en: 'LPN',
    es: 'LPN',
  },
  {
    en: 'Lumber Inspector',
    es: 'Lumber Inspector',
  },
  {
    en: 'Lumber Worker',
    es: 'Lumber Worker',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Machine Operator',
    es: 'Machine Operator',
  },
  {
    en: 'Machinist',
    es: 'Machinist - Maquinista',
  },
  {
    en: 'Mail Carrier',
    es: 'Mail Carrier - Cartero',
  },
  {
    en: 'Makeup and Wardrobe Personnel',
    es: 'Makeup and Wardrobe Personnel',
  },
  {
    en: 'Management Consultant',
    es: 'Management Consultant',
  },
  {
    en: 'Managing Director',
    es: 'Managing Director',
  },
  {
    en: 'Manicurist',
    es: 'Manicurist',
  },
  {
    en: 'Manufacturing (Abrasives)',
    es: 'Manufacturing (Abrasives)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Manufacturing (Acids)',
    es: 'Manufacturing (Acids)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Manufacturing (Chemicals)',
    es: 'Manufacturing (Chemicals)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Manufacturing (Metals)',
    es: 'Manufacturing (Metals)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Manufacturing (Munitions)',
    es: 'Manufacturing (Munitions)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Manufacturing (Plastics)',
    es: 'Manufacturing (Plastics)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Manufacturing (Weaponry)',
    es: 'Manufacturing (Weaponry)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Manufacturing Inspector',
    es: 'Manufacturing Inspector',
  },
  {
    en: 'Manufacturing, Foreman',
    es: 'Manufacturer, Foreman - Fabricante, encargado',
  },
  {
    en: 'Marijuana Budtender',
    es: 'Marijuana Budtender',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Courier or Delivery',
    es: 'Marijuana Courier or Delivery',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Distributor',
    es: 'Marijuana Distributor',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Grower',
    es: 'Marijuana Grower',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Processor',
    es: 'Marijuana Processor',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Retail Shop Employee',
    es: 'Marijuana Retail Shop Employee',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Retail Shop Owner',
    es: 'Marijuana Retail Shop Owner',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Reviewer',
    es: 'Marijuana Reviewer',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Security ',
    es: 'Marijuana Security ',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marijuana Trimmer',
    es: 'Marijuana Trimmer',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marina Owner/Manager',
    es: 'Marina Owner/Manager',
  },
  {
    en: 'Marine',
    es: 'Marine',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Marine Transportation/Shipping',
    es: 'Marine Transportation/Shipping - Transporte marítimo/Embarque',
  },
  {
    en: 'Marine Transportation/Shipping (w/ Foreign Travel)',
    es: 'Marine Transportation/Shipping (w/ Foreign Travel) - Transporte marítimo/Embarque (c/ viajes al extranjero)',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Market Research Analyst',
    es: 'Market Research Analyst',
  },
  {
    en: 'Marketing Assistant',
    es: 'Marketing Assistant',
  },
  {
    en: 'Marketing Consultant',
    es: 'Marketing Consultant',
  },
  {
    en: 'Marketing Director',
    es: 'Marketing Director',
  },
  {
    en: 'Martial Arts Teacher',
    es: 'Martial Arts Teacher',
  },
  {
    en: 'Mason',
    es: 'Mason - Cantero',
  },
  {
    en: 'Massage Therapist',
    es: 'Massage Therapist',
  },
  {
    en: 'Mathematician',
    es: 'Mathematician - Matemático',
  },
  {
    en: 'Mechanic',
    es: 'Mechanic - Mecánico',
  },
  {
    en: 'Mechanical Engineer',
    es: 'Mechanical Engineer',
  },
  {
    en: 'Medical Assistant',
    es: 'Medical Assistant',
  },
  {
    en: 'Medical Resident',
    es: 'Medical Resident - Médico residente',
  },
  {
    en: 'Medical Services Worker',
    es: 'Medical Services Worker',
  },
  {
    en: 'Medical Student',
    es: 'Medical Student - Estudiante de medicina',
  },
  {
    en: 'Medical Technician',
    es: 'Medical Technician',
  },
  {
    en: 'Meeting Planner',
    es: 'Meeting Planner',
  },
  {
    en: 'Metallurgist',
    es: 'Metallurgist - Metalúrgico',
  },
  {
    en: 'Metalworker',
    es: 'Metalworker',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Meteorologist',
    es: 'Meteorologist',
  },
  {
    en: 'Meter Reader',
    es: 'Meter Reader',
  },
  {
    en: 'Midwife',
    es: 'Midwife',
  },
  {
    en: 'Military',
    es: 'Military - Fuerzas Armadas',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Millwright',
    es: 'Millwright - Mecánico industrial',
  },
  {
    en: 'Miner',
    es: 'Miner - Minero',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Minister',
    es: 'Minister - Ministro',
  },
  {
    en: 'Model',
    es: 'Model',
  },
  {
    en: 'Mortgage Broker',
    es: 'Mortgage Broker',
  },
  {
    en: 'Mortgage Underwriter',
    es: 'Mortgage Underwriter',
  },
  {
    en: 'Mortician',
    es: 'Mortician - Empleado de funeraria',
  },
  {
    en: 'Moving and Storage Owner',
    es: 'Moving and Storage Owner',
  },
  {
    en: 'MRI Technologist',
    es: 'MRI Technologist',
  },
  {
    en: 'Museum Curator',
    es: 'Museum Curator',
  },
  {
    en: 'Music Teacher',
    es: 'Music Teacher',
  },
  {
    en: 'Musician',
    es: 'Musician - Músico',
  },
  {
    en: 'Nail Technician',
    es: 'Nail Technician',
  },
  {
    en: 'Nanny',
    es: 'Nanny',
  },
  {
    en: 'Naprapath',
    es: 'Naprapath',
  },
  {
    en: 'Naturopath',
    es: 'Naturopath',
  },
  {
    en: 'Navigator',
    es: 'Navigator - Navegante',
  },
  {
    en: 'Navy',
    es: 'Navy',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Neonatologist',
    es: 'Neonatologist',
  },
  {
    en: 'Nephrologist',
    es: 'Nephrologist',
  },
  {
    en: 'Network Engineer',
    es: 'Network Engineer',
  },
  {
    en: 'Neurological Surgery',
    es: 'Neurological Surgery',
  },
  {
    en: 'Neurologist',
    es: 'Neurologist',
  },
  {
    en: 'Newspaper Deliverer',
    es: 'Newspaper Deliverer',
  },
  {
    en: 'Newspaper Editor',
    es: 'Newspaper Editor',
  },
  {
    en: 'Newspaper Executive',
    es: 'Newspaper Executive',
  },
  {
    en: 'NFL Player ',
    es: 'NFL Player ',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Nightclubs (All Occupations)',
    es: 'Nightclubs (All Occupations)',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Nonprofit Professional',
    es: 'Nonprofit Professional',
  },
  {
    en: 'Nurse',
    es: 'Nurse - Enfermera',
  },
  {
    en: 'Nurse Anesthetist',
    es: 'Nurse Anesthetist',
  },
  {
    en: 'Nurse Practitioner',
    es: 'Nurse Practitioner - Enfermero profesional',
  },
  {
    en: 'Nurseryman',
    es: 'Nurseryman',
  },
  {
    en: 'Nursing Assistant',
    es: 'Nursing Assistant',
  },
  {
    en: 'Nutritionist',
    es: 'Nutritionist',
  },
  {
    en: 'OBGYN',
    es: 'OBGYN',
  },
  {
    en: 'Obstetrician',
    es: 'Obstetrician',
  },
  {
    en: 'Occupational Medicine Specialist',
    es: 'Occupational Medicine Specialist',
  },
  {
    en: 'Occupational Therapist',
    es: 'Occupational Therapist',
  },
  {
    en: 'Office Administrator',
    es: 'Office Administrator',
  },
  {
    en: 'Office Clerk',
    es: 'Office Clerk',
  },
  {
    en: 'Office Manager',
    es: 'Office Manager',
  },
  {
    en: 'Office Worker',
    es: 'Office Worker - Oficinista',
  },
  {
    en: 'Oil and Gas (Off-shore Drilling)',
    es: 'Oil and Gas (Off-shore Drilling)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Oncologist',
    es: 'Oncologist',
  },
  {
    en: 'Operations Manager',
    es: 'Operations Manager',
  },
  {
    en: 'Ophthalmologist',
    es: 'Ophthalmologist',
  },
  {
    en: 'Optician',
    es: 'Optician',
  },
  {
    en: 'Optometrist',
    es: 'Optometrist - Optometrista',
  },
  {
    en: 'Oral and Maxillofacial Surgeons',
    es: 'Oral and Maxillofacial Surgeons',
  },
  {
    en: 'Orderly',
    es: 'Orderly',
  },
  {
    en: 'Organizer',
    es: 'Organizer',
  },
  {
    en: 'Orthodontist',
    es: 'Orthodontist',
  },
  {
    en: 'Orthopedic Surgeon',
    es: 'Orthopedic Surgeon',
  },
  {
    en: 'Orthotist',
    es: 'Orthotist',
  },
  {
    en: 'Osteopath',
    es: 'Osteopath',
  },
  {
    en: 'Pain Management Specialist',
    es: 'Pain Management Specialist',
  },
  {
    en: 'Painter',
    es: 'Painter - Pintor',
  },
  {
    en: 'Paralegal',
    es: 'Paralegal',
  },
  {
    en: 'Paramedic',
    es: 'Paramedic',
  },
  {
    en: 'Parking Attendant',
    es: 'Parking Attendant',
  },
  {
    en: 'Pastor',
    es: 'Pastor',
  },
  {
    en: 'Pastry Chef',
    es: 'Pastry Chef',
  },
  {
    en: 'Pathologist',
    es: 'Pathologist',
  },
  {
    en: 'Pawnbroker',
    es: 'Pawnbroker',
  },
  {
    en: 'Payroll Clerk',
    es: 'Payroll Clerk - Pagador de personal',
  },
  {
    en: 'Pediatric Dentist',
    es: 'Pediatric Dentist',
  },
  {
    en: 'Pediatrician',
    es: 'Pediatrician',
  },
  {
    en: 'Performer',
    es: 'Performer - Artista',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: "Performer (Gentleman's/Exotic Club)",
    es: "Performer (Gentleman's/Exotic Club) - Artista (clubes exóticos para caballeros)",
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Perfusionist',
    es: 'Perfusionist',
  },
  {
    en: 'Personal Trainer',
    es: 'Personal Trainer',
  },
  {
    en: 'Personnel Agency Manager',
    es: 'Personnel Agency Manager',
  },
  {
    en: 'Pet Grooming',
    es: 'Pet Grooming',
  },
  {
    en: 'Pharmaceutical Sales Representative',
    es: 'Pharmaceutical Sales Representative',
  },
  {
    en: 'Pharmacist',
    es: 'Pharmacist - Farmacéutico',
  },
  {
    en: 'Pharmacy Technician',
    es: 'Pharmacy Technician',
  },
  {
    en: 'Photographer',
    es: 'Photographer - Fotógrafo',
  },
  {
    en: 'Physiatrist',
    es: 'Physiatrist',
  },
  {
    en: 'Physical Education Teacher',
    es: 'Physical Education Teacher',
  },
  {
    en: 'Physical Therapist',
    es: 'Physical Therapist',
  },
  {
    en: 'Physician',
    es: 'Physician - Médico',
  },
  {
    en: "Physician's Assistant",
    es: "Physician's Assistant",
  },
  {
    en: 'Physicist',
    es: 'Physicist - Físico',
  },
  {
    en: 'Piano Repairer',
    es: 'Piano Repairer',
  },
  {
    en: 'Pilot (commercial)',
    es: 'Pilot - Piloto',
  },
  {
    en: 'Pilot (private)',
    es: 'Pilot (private)',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Pipefitter',
    es: 'Pipefitter - Plomero',
  },
  {
    en: 'Plant Manager',
    es: 'Plant Manager',
  },
  {
    en: 'Plasterer',
    es: 'Plasterer - Yesero',
  },
  {
    en: 'Plumber',
    es: 'Plumber - Fontanero',
  },
  {
    en: 'Podiatrist',
    es: 'Podiatrist',
  },
  {
    en: 'Poker Player',
    es: 'Poker Player',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Police Officer',
    es: 'Police Officer',
  },
  {
    en: 'Police Officer (K-9)',
    es: 'Police Officer (K-9) - Oficial de policía (K-9)',
  },
  {
    en: 'Police Officer (Other)',
    es: 'Police Officer (Other) - Oficial de policía (otro)',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Police Officer (Patrol/Office/Supervisor)',
    es: 'Police Officer (Patrol/Office/Supervisor) - Oficial de policía (patrulla/oficina/supervisor)',
  },
  {
    en: 'Porter',
    es: 'Porter',
  },
  {
    en: 'Portfolio Manager',
    es: 'Portfolio Manager',
  },
  {
    en: 'Postal Inspector',
    es: 'Postal Inspector',
  },
  {
    en: 'Postmaster General',
    es: 'Postmaster General',
  },
  {
    en: 'President',
    es: 'President - Presidente',
  },
  {
    en: 'Principal',
    es: 'Principal - Director de escuela',
  },
  {
    en: 'Printer',
    es: 'Printer - Impresor',
  },
  {
    en: 'Private Equity',
    es: 'Private Equity',
  },
  {
    en: 'Procurement Manager',
    es: 'Procurement Manager',
  },
  {
    en: 'Producer',
    es: 'Producer - Productor',
  },
  {
    en: 'Product Manager',
    es: 'Product Manager',
  },
  {
    en: 'Product Marketing Manager',
    es: 'Product Marketing Manager',
  },
  {
    en: 'Product Owner',
    es: 'Product Owner',
  },
  {
    en: 'Production Personnel',
    es: 'Production Personnel',
  },
  {
    en: 'Production Supervisor',
    es: 'Production Supervisor',
  },
  {
    en: 'Professional Athlete',
    es: 'Professional Athlete',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Professional Wrestler',
    es: 'Athlete - Wrestler - Atleta - Luchador',
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Professor',
    es: 'Professor - Profesor',
  },
  {
    en: 'Program Administrator',
    es: 'Program Administrator',
  },
  {
    en: 'Program Manager',
    es: 'Program Manager',
  },
  {
    en: 'Programmer',
    es: 'Programmer - Programador',
  },
  {
    en: 'Project Coordinator',
    es: 'Project Coordinator',
  },
  {
    en: 'Project Manager',
    es: 'Project Manager - Gerente de proyectos',
  },
  {
    en: 'Projectionist',
    es: 'Projectionist',
  },
  {
    en: 'Proofreader',
    es: 'Proofreader',
  },
  {
    en: 'Property Management',
    es: 'Property Management',
  },
  {
    en: 'Prosthetist',
    es: 'Prosthetist',
  },
  {
    en: 'Prosthodontist',
    es: 'Prosthodontist',
  },
  {
    en: 'Psychiatric Nurse',
    es: 'Psychiatric Nurse',
  },
  {
    en: 'Psychiatrist',
    es: 'Psychiatrist - Psiquiatra',
  },
  {
    en: 'Psychologist',
    es: 'Psychologist - Psicólogo',
  },
  {
    en: 'Psychotherapist',
    es: 'Psychotherapist',
  },
  {
    en: 'Public Affairs Manager',
    es: 'Public Affairs Manager',
  },
  {
    en: 'Public Relations Agent',
    es: 'Public Relations Agent',
  },
  {
    en: 'Public Speaker',
    es: 'Public Speaker',
  },
  {
    en: 'Publisher',
    es: 'Publisher',
  },
  {
    en: 'Publishing Executive',
    es: 'Publishing Executive',
  },
  {
    en: 'Pulmonologists',
    es: 'Pulmonologists',
  },
  {
    en: 'Purchasing Agent',
    es: 'Purchasing Agent',
  },
  {
    en: 'Pyrotechnist',
    es: 'Pyrotechnist',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Quality Assurance Manager',
    es: 'Quality Assurance Manager',
  },
  {
    en: 'Quality Engineer',
    es: 'Quality Engineer',
  },
  {
    en: 'Rabbi',
    es: 'Rabbi',
  },
  {
    en: 'Racecar Driver',
    es: 'Racecar Driver',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Radiation Therapist',
    es: 'Radiation Therapist',
  },
  {
    en: 'Radio Announcer',
    es: 'Radio Announcer',
  },
  {
    en: 'Radiologist',
    es: 'Radiologist - Radiólogo',
  },
  {
    en: 'Railroad Inspector',
    es: 'Railroad Inspector',
  },
  {
    en: 'Rancher',
    es: 'Ranch Manager',
  },
  {
    en: 'Real Estate',
    es: 'Real Estate',
  },
  {
    en: 'Real Estate Agent or Broker',
    es: 'Real Estate Agent or Broker',
  },
  {
    en: 'Real Estate Appraiser',
    es: 'Real Estate Appraiser',
  },
  {
    en: 'Real Estate Developer',
    es: 'Real Estate Developer',
  },
  {
    en: 'Real Estate Inspector',
    es: 'Real Estate Inspector',
  },
  {
    en: 'Real Estate Investor',
    es: 'Real Estate Investor',
  },
  {
    en: 'Real Estate Management',
    es: 'Real Estate Management',
  },
  {
    en: 'Real Estate Owner',
    es: 'Real Estate Owner',
  },
  {
    en: 'Realtor',
    es: 'Realtor - Corredor de bienes raíces',
  },
  {
    en: 'Receptionist',
    es: 'Receptionist - Recepcionista',
  },
  {
    en: 'Recruiter',
    es: 'Recruiter',
  },
  {
    en: 'Referee',
    es: 'Referee',
  },
  {
    en: 'Regional Sales Manager',
    es: 'Regional Sales Manager',
  },
  {
    en: 'Registered Nurse',
    es: 'Registered Nurse',
  },
  {
    en: 'Registrar',
    es: 'Registrar - Registrador',
  },
  {
    en: 'Reliability Engineer',
    es: 'Reliability Engineer',
  },
  {
    en: 'Repairman',
    es: 'Repairman - Reparador',
  },
  {
    en: 'Reporter',
    es: 'Reporter - Reportero',
  },
  {
    en: 'Research Scientist',
    es: 'Research Scientist',
  },
  {
    en: 'Researcher',
    es: 'Researcher',
  },
  {
    en: 'Respiratory Therapist',
    es: 'Respiratory Therapist',
  },
  {
    en: 'Restaurant Inspector',
    es: 'Restaurant Inspector',
  },
  {
    en: 'Restaurant Owner/Manager',
    es: 'Restaurant Manager',
  },
  {
    en: 'Retail Owner/Manager',
    es: 'Retail Owner',
  },
  {
    en: 'Retail Sales',
    es: 'Retail Sales',
  },
  {
    en: 'Retired',
    es: 'Retired - Jubilado',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Rheumatologist',
    es: 'Rheumatologist',
  },
  {
    en: 'Risk Analyst',
    es: 'Risk Analyst',
  },
  {
    en: 'Risk Manager',
    es: 'Risk Manager',
  },
  {
    en: 'Roofer',
    es: 'Roofer - Techador',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Sailor',
    es: 'Sailor',
  },
  {
    en: 'Sales Clerk',
    es: 'Sales Clerk',
  },
  {
    en: 'Sales Director',
    es: 'Sales Director',
  },
  {
    en: 'Sales Executive',
    es: 'Sales Executive',
  },
  {
    en: 'Sales Manager',
    es: 'Sales Manager',
  },
  {
    en: 'Salesperson',
    es: 'Sales Person - Personal de ventas',
  },
  {
    en: 'Salon Owner',
    es: 'Salon Owner',
  },
  {
    en: 'Sandhog',
    es: 'Sandhog',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Sanitation Inspector',
    es: 'Sanitation Inspector',
  },
  {
    en: 'Sanitation Worker',
    es: 'Sanitation Worker',
  },
  {
    en: 'Sawmill Worker',
    es: 'Sawmill Worker',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'School Bus Driver',
    es: 'School Bus Driver',
  },
  {
    en: 'School Counselor',
    es: 'School Counselor',
  },
  {
    en: 'School Principal',
    es: 'School Principal',
  },
  {
    en: 'School Psychologist',
    es: 'School Psychologist',
  },
  {
    en: 'School Superintendent',
    es: 'School Superintendent',
  },
  {
    en: 'Scientist',
    es: 'Scientist - Científico',
  },
  {
    en: 'Seamstress',
    es: 'Seamstress - Costurera',
  },
  {
    en: 'Seasonal Worker',
    es: 'Seasonal Worker',
  },
  {
    en: 'Secret Service',
    es: 'Secret Service',
    ratingCap: 'KNOCKOUT',
  },
  {
    en: 'Secretary',
    es: 'Secretary - Secretaria',
  },
  {
    en: 'Security',
    es: 'Security',
  },
  {
    en: 'Security Officer',
    es: 'Security Officer',
  },
  {
    en: 'Server',
    es: 'Server - Mesera',
  },
  {
    en: "Server (Gentleman's/Exotic Club)",
    es: "Server (Gentleman's/Exotic Club) - Mesera (club exótico para caballeros)",
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Service Station Attendant',
    es: 'Service Station Attendant',
  },
  {
    en: 'Service Station Owner',
    es: 'Service Station Owner',
  },
  {
    en: 'Service Technician',
    es: 'Service Technician',
  },
  {
    en: 'Serviceman',
    es: 'Serviceman - Soldado',
  },
  {
    en: 'Shipbuilder',
    es: 'Shipbuilder',
  },
  {
    en: 'Shipper',
    es: 'Shipper - Despachante',
  },
  {
    en: 'Shoe Repair',
    es: 'Shoe Repair',
  },
  {
    en: 'Shoemaker',
    es: 'Shoemaker - Zapatero',
  },
  {
    en: 'Sign Language Interpreter',
    es: 'Sign Language Interpreter',
  },
  {
    en: 'Sign/Billboard Production',
    es: 'Sign/Billboard Production',
  },
  {
    en: 'Signalman',
    es: 'Signalman',
  },
  {
    en: 'Singer',
    es: 'Singer',
  },
  {
    en: 'Site Manager',
    es: 'Site Manager',
  },
  {
    en: 'Skating Rink',
    es: 'Skating Rink',
  },
  {
    en: 'Slaughterhouse Worker',
    es: 'Slaughterhouse Worker',
  },
  {
    en: 'Small Business Owner',
    es: 'Small Business Owner',
  },
  {
    en: 'Social Worker',
    es: 'Social Worker - Trabajador social',
  },
  {
    en: 'Software Consultant',
    es: 'Software Consultant',
  },
  {
    en: 'Software Designer',
    es: 'Software Designer',
  },
  {
    en: 'Software Engineer',
    es: 'Software Engineer',
  },
  {
    en: 'Software Tester',
    es: 'Software Tester',
  },
  {
    en: 'Sound Engineer',
    es: 'Sound Engineer',
  },
  {
    en: 'Speech Pathologist',
    es: 'Speech Pathologist',
  },
  {
    en: 'Speech Therapist',
    es: 'Speech Therapist',
  },
  {
    en: 'Stable Worker',
    es: 'Stable Worker',
  },
  {
    en: 'Stage Manager',
    es: 'Stage Manager',
  },
  {
    en: 'Stagehand',
    es: 'Stagehand',
  },
  {
    en: 'State Trooper',
    es: 'State Trooper',
  },
  {
    en: 'Statistician',
    es: 'Statistician - Estadístico',
  },
  {
    en: 'Steelworker',
    es: 'Steelworker',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Steeplejack',
    es: 'Steeplejack',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Stenographer',
    es: 'Stenographer',
  },
  {
    en: 'Stenotyper',
    es: 'Stenotyper',
  },
  {
    en: 'Stewardess',
    es: 'Stewardess',
  },
  {
    en: 'Stock Broker',
    es: 'Stock Broker',
  },
  {
    en: 'Stock Clerk',
    es: 'Stock Clerk',
  },
  {
    en: 'Stock Trader',
    es: 'Stock Trader',
  },
  {
    en: 'Store Manager',
    es: 'Store Manager',
  },
  {
    en: 'Student',
    es: 'Student - Estudiante',
  },
  {
    en: 'Stuntman/Stuntwoman',
    es: 'Stuntman/Stuntwoman - Doble de riesgo',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Substitute Teacher',
    es: 'Substitute Teacher',
  },
  {
    en: 'Superintendent',
    es: 'Superintendent',
  },
  {
    en: 'Supermarket Owner/Manager',
    es: 'Supermarket Owner',
  },
  {
    en: 'Surgeon',
    es: 'Surgeon - Médico cirujano',
  },
  {
    en: 'Surveyor',
    es: 'Surveyor - Topógrafo',
  },
  {
    en: 'Switchboard Operator',
    es: 'Switchboard Operator',
  },
  {
    en: 'System Administrator',
    es: 'System Administrator',
  },
  {
    en: 'Systems Analyst',
    es: 'Systems Analyst',
  },
  {
    en: 'Systems Engineer',
    es: 'Systems Engineer',
  },
  {
    en: 'Tailor',
    es: 'Tailor - Sastre',
  },
  {
    en: 'Talent Management Director',
    es: 'Talent Management Director',
  },
  {
    en: 'Taxi Driver',
    es: 'Taxi Driver',
  },
  {
    en: 'Taxidermist',
    es: 'Taxidermist',
  },
  {
    en: 'Teacher',
    es: 'Teacher - Maestro',
  },
  {
    en: "Teacher's aide",
    es: "Teacher's aide",
  },
  {
    en: 'Tech Support',
    es: 'Tech Support',
  },
  {
    en: 'Technical Analyst',
    es: 'Technical Analyst',
  },
  {
    en: 'Technical Writer',
    es: 'Technical Writer',
  },
  {
    en: 'Technician',
    es: 'Technician - Técnico',
  },
  {
    en: 'Technologist',
    es: 'Technologist - Tecnólogo',
  },
  {
    en: 'Telegrapher',
    es: 'Telegrapher',
  },
  {
    en: 'Teller',
    es: 'Teller',
  },
  {
    en: 'Tennis Club Attendant',
    es: 'Tennis Club Attendant',
  },
  {
    en: 'Tennis Club Owner/Manager',
    es: 'Tennis Club Owner',
  },
  {
    en: 'Tennis Club Professional',
    es: 'Tennis Club Professional',
  },
  {
    en: 'Tennis Instructor',
    es: 'Tennis Instructor',
  },
  {
    en: 'Test Driver',
    es: 'Test Driver',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Theater Manager',
    es: 'Theater Manager',
  },
  {
    en: 'Therapist',
    es: 'Therapist - Terapeuta',
  },
  {
    en: 'Thoracic Surgeon',
    es: 'Thoracic Surgeon',
  },
  {
    en: 'Ticket Agent',
    es: 'Ticket Agent',
  },
  {
    en: 'Trapeze Artist',
    es: 'Trapeze Artist',
    ratingCap: 'KNOCKOUT',
    flatExtra: 2.5,
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Tree Removal',
    es: 'Tree Removal',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Truck Driver',
    es: 'Truck Driver',
  },
  {
    en: 'Underwriter',
    es: 'Insurance Underwriter',
  },
  {
    en: 'Venture Capitalist',
    es: 'Venture Capitalist',
  },
  {
    en: 'Vet Technician',
    es: 'Vet Technician',
  },
  {
    en: 'Veterinarian',
    es: 'Veterinarian - Veterinario',
  },
  {
    en: 'Vice President',
    es: 'Vice President - Vicepresidente',
  },
  {
    en: 'Video Production',
    es: 'Video Production',
  },
  {
    en: "Waiter (Gentleman's/Exotic Club)",
    es: "Waiter (Gentleman's/Exotic Club) - Camarero (club exótico para caballeros)",
    ratingCap: 'REJECT_WITH_VANTAGE',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Waiter/Waitress',
    es: 'Waiter - Camarero',
  },
  {
    en: 'Warehouse Owner/Manager',
    es: 'Warehouse Owner',
  },
  {
    en: 'Warehouse Worker',
    es: 'Warehouse Worker',
  },
  {
    en: 'Waste Removal (Hazardous)',
    es: 'Waste Removal (Hazardous)',
    ratingCap: 'STANDARD',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Watch Repair',
    es: 'Watch Repair',
  },
  {
    en: 'Watchmaker',
    es: 'Watchmaker',
  },
  {
    en: 'Water Processing Plant Worker',
    es: 'Water Processing Plant Worker',
  },
  {
    en: 'Water Treatment Plant Operator',
    es: 'Water Treatment Plant Operator',
  },
  {
    en: 'Weaver',
    es: 'Weaver',
  },
  {
    en: 'Web Architect',
    es: 'Web Architect',
  },
  {
    en: 'Web Designer',
    es: 'Web Designer',
  },
  {
    en: 'Web Developer',
    es: 'Web Developer',
  },
  {
    en: 'Welder',
    es: 'Welder - Soldador',
  },
  {
    en: 'Well Driller',
    es: 'Well Driller',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Window Cleaner',
    es: 'Window Cleaner - Limpieza de ventanas',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Window Decorator',
    es: 'Window Decorator',
  },
  {
    en: 'Woodworker',
    es: 'Woodworker',
  },
  {
    en: 'Writer',
    es: 'Writer',
  },
  {
    en: 'X-Ray Technician',
    es: 'X-Ray Technician',
  },
  {
    en: 'Yard Worker',
    es: 'Yard Worker',
  },
  {
    en: 'Zoo Attendant',
    es: 'Zoo Attendant',
  },
  {
    en: 'Zookeeper',
    es: 'Zookeeper',
  },
  {
    en: 'Zoologist',
    es: 'Zoologist',
  },
  {
    en: 'Unemployed',
    es: 'Unemployed',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Disabled',
    es: 'Disabled',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
  {
    en: 'Stay at Home Parent',
    es: 'Stay at Home Parent',
    ratingCap: 'KNOCKOUT',
    wpRatingCap: 'KNOCKOUT',
  },
];

const occupationsToRemoveFromNY = [
  'Golf Pro',
  'Poker Player',
  'Retired',
  'Student',
  'Unemployed',
  'Disabled',
  'Stay at Home Parent',
];
const occupationsToAddtoNY = [
  'Massage Facility Owner',
  'Palm Reader',
  'Psychic',
  'Spa Owner',
  'Spa Worker',
  'Tarot Card Reader',
  'Foreman',
];

const occupationListNY = occupationList.filter((occupation) => !occupationsToRemoveFromNY.includes(occupation.en));

occupationsToAddtoNY.forEach((occupation) => {
  occupationListNY.push({ en: occupation, es: occupation });
});

export const Occupations = {
  occupationList,
  occupationListNY,
};
